// Call notes as typed (QA-771): kept by call until the call has them. Any call's event re-reads the open
// call, and another call can be opened mid-sentence; neither empties the box. "Saved on the call" stays
// true: a pause in typing saves them (NOTES_SAVE_MS), and leaving the call saves what's left.

/** How long typing pauses before the notes are saved on the call. */
export const NOTES_SAVE_MS = 800;

/** Notes as the server keeps them: trimmed, and nothing is none. */
export const notesValue = (text: string): string | null => text.trim() || null;

export class NoteDrafts {
  private typed = new Map<string, string>();

  /** Typed into a call's box. */
  type(callId: string, text: string): void {
    this.typed.set(callId, text);
  }

  /** What a call's box shows, read with the notes it has: what's typed and not on it yet, else its own. */
  shown(callId: string, saved: string | null): string {
    return this.typed.get(callId) ?? saved ?? '';
  }

  /** What's still to save on a call: null when the call has what was typed. */
  pending(callId: string): string | null {
    return this.typed.get(callId) ?? null;
  }

  /** The call now has `saved`: a draft that says the same is done with; one typed on since stays. */
  saved(callId: string, saved: string | null): void {
    const t = this.typed.get(callId);
    if (t !== undefined && notesValue(t) === (saved ?? null)) this.typed.delete(callId);
  }
}
